import { Dropdown as AntDropdown, theme } from 'antd';
import React from 'react';

const { useToken } = theme;

export const Dropdown = React.memo(
  ({ children, overlayClassName, className, open, onOpenChange, content, ...props }) => {
    const { token } = useToken();
    return (
      <AntDropdown
        overlayStyle={{
          padding: token.paddingXXS,
          borderRadius: token.borderRadiusSM,
          backgroundColor: token.colorBgElevated,
        }}
        dropdownRender={() => content}
        destroyPopupOnHide
        open={open}
        onOpenChange={onOpenChange}
        overlayClassName={`editor__root-dropdown${overlayClassName ? ' ' + overlayClassName : ''}`}
        className={className}
        arrow={false}
        trigger={['click']}
        placement="bottom"
        {...props}
      >
        {children}
      </AntDropdown>
    );
  }
);

export default Dropdown;
